import {Box, Link, Typography} from '@mui/material';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import nl2br from 'react-nl2br';

type Props = {
    bio: string;
    maxChars?: number;
};

function Bio({bio, maxChars = 200}: Props) {
    const {t} = useTranslation('app');
    const [expanded, setExpanded] = useState(false);

    const chars = Array.from(bio);
    const isTruncatable = chars.length > maxChars;
    const displayedBio =
        isTruncatable && !expanded
            ? `${chars.slice(0, maxChars).join('')}…`
            : bio;

    return (
        <Typography
            variant="body2"
            color="text.secondary"
            component="div"
            sx={theme => ({
                mt: 1,
                p: 2,
                borderLeft: `2px solid ${theme.palette.divider}`,
            })}
        >
            <Box component="span">{nl2br(displayedBio)}</Box>
            {isTruncatable && (
                <Link
                    component="button"
                    type="button"
                    variant="body2"
                    aria-expanded={expanded}
                    onClick={() => setExpanded(prev => !prev)}
                    sx={{
                        display: 'block',
                        mt: 0.5,
                    }}
                >
                    {expanded
                        ? t('app:profile.bio.view_less', 'View less')
                        : t('app:profile.bio.view_more', 'View more')}
                </Link>
            )}
        </Typography>
    );
}

export default Bio;
